import {Stack, styled} from '@mui/material';

const ExamsContainer = styled(Stack)`
	padding-inline: 16px;
	padding-top: 16px;
	gap: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: 32px;
		padding-top: 24px;
	}
`;

export {ExamsContainer};
